
/**
* An interface of the complied template function containing also its source
*/
interface CompliedTemplate {
	(...args ):any;
}

interface TemplatePass {
	regex:RegExp;
	mapper:( match:string, inner:string ) => string;
}


/**
 *
 */
class Renderer {

	public context:any = { };
	public logging:boolean = false;

	public pass:TemplatePass = {
		regex:/\[\[([\s\S]+?)\]\]/g,
		mapper: function( match, inner ) {
			return "function() { try { with( data ) { return " + inner + " } } catch (error) { this.log( error ) } }.call( this )";
		}
	};

	private cache:{} = {};

	/**
	* Renders the given data into the given template string
	*/
	render( template:string, data:any = {} ):any {
		return this.compile(template)( data );
	}

	/**
	 * Compiles a template string into a template function.
	 */
	compile( templateString:string, args = 'data' ):CompliedTemplate {

		// handle caching
		if( this.cache[ templateString ] ) return this.cache[ templateString ]

		// check if template is one single [[ .. ]] expression
		let matches = templateString.match( /\[\[([\s\S]+?)\]\]/ );
		if( matches && matches[0] == templateString ) {
			var source = this.parseValue( templateString );
		} else {
			var source = this.parseString( templateString );
		}

		var render = new Function( args, source );
		var contx = this.context;

		// wrap function to adjust context
		var func = function():any {
			return render.apply( contx, arguments );
		}

		// store for caching
		this.cache[ templateString ] = func;

		return func;
	}

	/**
		* Turns the given template into a function body code.
		*/
	parseString( template:string ):string {

		template = template.replace( this.pass.regex, ( match, inner:string ) => {
			return "' + __c.empty( " + this.pass.mapper( match, inner ) + " ) + '";
		});

		// finalize full template instructions
		template = "__t= '" + template + "';\n";

		// add opt variable for optional access
		return 'var __t;\nvar __c = this;' + template + 'return __t;'
	}

	/**
	* Turns the given template into a function body code.
	*/
	parseValue( template:string ):string {

		// loop over all passes
		template = template.replace( this.pass.regex, this.pass.mapper );

		// finalize full template instructions
		template = "__t = " + template + ";\n";

		// add opt variable for optional access
		return 'var __t;\nvar __c = this;' + template + 'return __t;'
	}

	/**
	 * Tests if the value of the template is empty or not
	 */
	empty( data:any ):string {
		return data || data === 0 ? data : '';
	}

	/**
	 * Logs errors to the console
	 */
	log( error ) {
		if( !this.logging ) return;

		if( console ) {
			( console.trace ) ? console.trace( error ) : console.log( error );
		}
	}

	/**
	 * Stops the debugger
	 */
	debug() {
		debugger;
	}
}


export var renderer = new Renderer();
renderer.context.empty = renderer.empty;
renderer.context.log = renderer.log.bind( renderer );
renderer.context.debug = renderer.debug;


export default Renderer;
